import axios from "@utils/axios-instance";
import { TMyTasksFilters, TTasksResponse } from "@/models/tasks.model";

const buildQuery = (filters: TMyTasksFilters): string => {
  const params = Object.fromEntries(
    Object.entries(filters)
      .filter(([, val]) => val !== undefined && val !== null)
      .map(([k, v]) => [k, String(v)])
  );
  return new URLSearchParams(params).toString();
};

/** Company-wide task list (GET /task) — requires tasks.viewAll on the backend. */
export const getMyTasks = async (filters: TMyTasksFilters = {}): Promise<TTasksResponse> => {
  const queryString = buildQuery(filters);
  const response = await axios.get(`/task${queryString ? `?${queryString}` : ""}`);
  return response.data;
};

/** Tasks assigned to the calling user (GET /task/me) — no extra permission needed. */
export const getOwnTasks = async (filters: TMyTasksFilters = {}): Promise<TTasksResponse> => {
  const queryString = buildQuery(filters);
  const response = await axios.get(`/task/me${queryString ? `?${queryString}` : ""}`);
  return response.data;
};
